import React, { useEffect, useState } from "react";
import { configs, formatCurrency, formatNumber } from "../../../assets/Config";
import { useLogin } from "../../../services/contexts/AdminLoginContext";
import LeftBarPage from "../../includes/dashboard/LeftBarPage";
import TopBarPage from "../../includes/dashboard/TopBarPage";
import "../../../assets/styles/BuyOrder.css"
import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";
import { useKYCContext } from "../../../services/contexts/KYCContext";
import { useBuyOrderContext } from "../../../services/contexts/BuyOrdersContext";
import ToastPage from "../../includes/ToastPage";
import { useHistory } from "react-router";
import { useSellOrderContext } from "../../../services/contexts/SellOrdersContext";
import { useDistributorContext } from "../../../services/contexts/DistributorContext";
import { useCMContext } from "../../../services/contexts/companyManagement/CMContext";
import { getInventoryByCompany } from "../../../services/apis/shareManagement/InventoryAPI";
import { useRMContext } from "../../../services/contexts/RMContext";
import { getUTMList } from "../../../services/apis/KYCApi";

export default function ManualPunchComponent() {

    const { getKYCVerifiedCustomer, kycVerifiedList } = useKYCContext()
    const { getCompanyList, getCompanySlabsByCompanyId, manualOrderPunch, editManualPunch, setEditManualPunch, approveHighValueOrderById, activeStatus, getOrdersByType } = useBuyOrderContext()
    const { getCompanyDataById } = useCMContext()
    const { sellManualOrderPunch, editManualPunchSell, setEditManualPunchSell, editSellOrderById, getSellOrder, activeStatusSell } = useSellOrderContext()
    const { setCurrModule, setShowSuccess, allowedFunc, token, logout, setLoginError } = useLogin()
    const { adminList, getAllAdmin } = useRMContext()


    const [email, setEmail] = useState("")
    const [name, setName] = useState("")
    const [mobile, setMobile] = useState("")
    const [pan, setPan] = useState("")
    const [companyList, setCompanyList] = useState("")
    const [companySlabs, setCompnaySlabs] = useState("")
    const [inventory, setInventory] = useState("")
    const [orderType, setOrderType] = useState("buy");
    const [dealerOrder, setDealerOrder] = useState(0);
    const [esopHolder, setEsopHolder] = useState(0);

    const [companyId, setCompanyId] = useState("")
    const [customerId, setCustomerId] = useState("")
    const [customer, setCustomer] = useState("");
    const [quantity, setQuantity] = useState("")

    const [distributor, setDistributor] = useState("")
    const [distributorList, setDistributorList] = useState([])
    const [upmark, setUpmark] = useState("")
    const [upmarkPay, setUpmarkPay] = useState("")
    const [allowUserUpdate, setAllowUserUpdate] = useState(false)
    const [allow_regular_commission, setAllow_regular_commission] = useState(0)
    const [allow_advance_dealer_delivery, setAllow_advance_dealer_delivery] = useState(0)
    const [deal_done_by_admin_id, setdeal_done_by_admin_id] = useState("")

    const [price, setPrice] = useState("")
    const [error, setError] = useState("")

    const history = useHistory()


    useEffect(() => {
        try {
            if (allowedFunc.includes(configs.functionList["buy_module:buy_order_manual_punching"]) || allowedFunc.includes(configs.functionList["sell_module:sell_order_manual_punching"]) || allowedFunc.includes(configs.functionList['buy_module:load_all_buy_orders']) || allowedFunc.includes(configs.functionList['buy_module:update_buy_order'])) {
                (async () => {
                    getAllAdmin();
                    editManualPunch ? getKYCVerifiedCustomer(null, configs.allRecordsFetchedTillNow) : getKYCVerifiedCustomer();
                    let response = await getCompanyList()
                    if (response.success) {
                        setCompanyList(response.data)
                    } else {

                    }
                    try {
                        let distRes = await getUTMList(token)
                        if (distRes && distRes.status === 200 && Array.isArray(distRes.data)) {
                            setDistributorList(distRes.data)
                        }
                    } catch (e) {
                        console.error(e)
                    }
                })()

                if (editManualPunch) {
                    handleNameChange(null, editManualPunch ? editManualPunch.user : "", editManualPunch.distributor)
                }
                if (editManualPunchSell) {
                    setOrderType("sell")
                    handleNameChange(null, editManualPunchSell.user || "", editManualPunchSell.distributor || null)
                    setQuantity(editManualPunchSell.quantity || "")
                    setPrice(editManualPunchSell.price_per_share || "")
                    setDealerOrder(editManualPunchSell.is_dealer_order ? 1 : 0)
                    setEsopHolder(!!editManualPunchSell.esop_holder ? 1 : 0)
                    setdeal_done_by_admin_id(editManualPunchSell.deal_done_by || "")
                    setAllowUserUpdate(!!editManualPunchSell.allow_user_update)
                    setUpmark(editManualPunchSell.upmark ? editManualPunchSell.upmark : "")
                    setUpmarkPay(editManualPunchSell.upmark_final_pay ? editManualPunchSell.upmark_final_pay : "")
                    // Prefer order-level tagged distributor over user's default distributor
                    if (editManualPunchSell.distributor && editManualPunchSell.distributor.id) {
                        setDistributor(editManualPunchSell.distributor)
                    }
                }
            } else {
                return history.goBack()
            }
        } catch (error) {
            console.error(error)
        }

        // Clear edit state on unmount so a stale edit doesn't reopen when returning to this page
        return () => {
            try {
                setEditManualPunch(false)
                if (setEditManualPunchSell) setEditManualPunchSell(false)
            } catch (e) {
                console.error(e)
            }
        }
    }, [])

    useEffect(() => {
        if (editManualPunchSell && companyList && Array.isArray(companyList)) {
            const companyId = editManualPunchSell.company_id || (editManualPunchSell.company && editManualPunchSell.company.id)
            const company = companyId
                ? companyList.find((c) => c.id === companyId)
                : companyList.find((c) => c.name === editManualPunchSell.company_name)
            if (company) {
                handleCompanyChange(null, company)
            }
        }
    }, [editManualPunchSell, companyList])

    // Resolve the tagged distributor to the matching item from distributorList so the Autocomplete recognizes it
    useEffect(() => {
        if (distributor && distributor.id && Array.isArray(distributorList) && distributorList.length > 0) {
            const matched = distributorList.find((d) => d.id === distributor.id)
            if (matched && matched !== distributor) {
                setDistributor(matched)
            }
        }
    }, [distributorList])

    const handleNameChange = (e, value, distributor) => {
        try {
            setCustomer(value)
            setEmail(value.email)
            setName(value.name)
            setPan(value.pan_number)
            setMobile(value.mobile ? `+${value.mobile}` : value.mobile)
            setCustomerId(value.id)
            setDistributor(value.distributor ? value.distributor : distributor);
            setdeal_done_by_admin_id(value.relationship_manager ? value.relationship_manager : "")

            if (editManualPunch) {
                handleCompanyChange(null, { id: editManualPunch.company ? editManualPunch.company.id : editManualPunch.company_id ? editManualPunch.company_id : "" });
                setQuantity(editManualPunch.quantity)
                setPrice(editManualPunch.price_per_share)
                setUpmark(editManualPunch.upmark ? editManualPunch.upmark : "")
                setUpmarkPay(editManualPunch.upmark_final_pay ? editManualPunch.upmark_final_pay : "")
                setDealerOrder(editManualPunch.dealer_order ? editManualPunch.dealer_order : 0)
                setdeal_done_by_admin_id(editManualPunch.deal_done_by)
            }

            if (!value.distributor || !value.distributor.id) {
                setUpmark("")
                setUpmarkPay("")
            }

        } catch (error) {

        }
    }

    const handleRMChange = (e, value) => {
        try {
            setdeal_done_by_admin_id(value)
        } catch (error) {

        }
    }

    const handleCompanyChange = async (e, value) => {
        try {
            setCompanyId(value.id)
            if (value.id) {
                let response = await getCompanySlabsByCompanyId(value.id);
                if (response && response.success) {
                    setCompnaySlabs(response.data)
                }
                response = await getInventoryByCompany(token, value.id);
                if (response && response.status === 200) {
                    setInventory(response.data?.analytics?.data[0])
                } else if (response && response.status === 401) {
                    logout()
                    setLoginError(configs.unauthorizedErrorMessage)
                } else {
                    setError(response.data.error)
                }
            }
        } catch (error) {
            console.error(error);
        }
    }

    // manual order punch
    async function manualPunch() {
        try {
            document.getElementById("manualPunchBtn").classList.toggle("d-none")
            document.getElementById("manualPunchBtnLoader").classList.toggle("d-none")

            const re = /^[0-9]+$/;
            const red = /^[0-9]\d*(\.\d{1,2})?$/;
            if (editManualPunchSell) {
                // sell edit: quantity, price_per_share, deal_done_by_admin_id, new_user_id (only if allow_user_update was true), upmark, upmark_final_pay, distributor_id, is_dealer_order, esop_holder
                if (!quantity.toString().match(re)) {
                    setError("Please enter a valid quantity with only numbers.")
                } else if (!parseFloat(price).toFixed(2).toString().match(red)) {
                    setError("Please enter a valid price with only numbers.")
                } else if ((!upmark && upmarkPay && distributor && distributor.id) || (upmark && isNaN(upmark))) {
                    setError("Please enter a valid Upmark value.")
                } else if ((upmark && !upmarkPay && distributor && distributor.id) || (upmarkPay && isNaN(upmarkPay))) {
                    setError("Please enter a valid Upmark Final Pay value.")
                } else {
                    let response;
                    const dealDoneByAdminId = deal_done_by_admin_id && typeof deal_done_by_admin_id === 'object' && deal_done_by_admin_id.id != null
                        ? deal_done_by_admin_id.id
                        : (typeof deal_done_by_admin_id === 'number' || (typeof deal_done_by_admin_id === 'string' && deal_done_by_admin_id !== ''))
                            ? deal_done_by_admin_id
                            : undefined
                    const originalUserId = editManualPunchSell.user ? editManualPunchSell.user.id : editManualPunchSell.user_id
                    // Only allow changing the customer when the order originally had allow_user_update = true
                    const newUserId = editManualPunchSell.allow_user_update && customerId && customerId !== originalUserId ? customerId : ""
                    const distributorId = distributor && distributor.id ? distributor.id : ""
                    response = await editSellOrderById(editManualPunchSell.id, quantity, price, dealDoneByAdminId, esopHolder, undefined, newUserId, upmark, upmarkPay, distributorId, dealerOrder);
                    if (response === "success") {
                        setShowSuccess(true);
                        getSellOrder(configs.sellOrderStatusTypes[activeStatusSell].api, configs.startPage, configs.allRecordsFetchedTillNow, true);
                        setEditManualPunchSell(false);
                        resetAll();
                    } else {
                        setError(response);
                    }
                }
            } else if (!customerId) {
                setError("Please select a valid customer.")
            } else if (!companyId) {
                setError("Please select a valid company.")
            } else if (!quantity.toString().match(re)) {
                setError("Please enter a valid quantity with only numbers.")
            } else if (!parseFloat(price).toFixed(2).toString().match(red)) {
                setError("Please enter a valid price with only numbers.")
            } else if ((!upmark && upmarkPay && distributor.id) || (upmark && isNaN(upmark))) {
                setError("Please enter a valid Upmark value.")
            } else if ((upmark && !upmarkPay && distributor.id) || (upmarkPay && isNaN(upmarkPay))) {
                setError("Please enter a valid Upmark Final Pay value.")
            } else if ((upmark && upmarkPay && !distributor.id)) {
                setError("Please select a valid distributor.")
            } else {
                let response;
                if (editManualPunch && editManualPunch.company_id) {
                    response = await approveHighValueOrderById(editManualPunch.id, quantity, price, customerId === editManualPunch.user.id ? "" : customerId, upmark, upmarkPay, true, distributor ? distributor.id : "", deal_done_by_admin_id.id);
                    if (response.success) {
                        setShowSuccess(true)
                        getOrdersByType(configs.shareStatusTypes[activeStatus].api, configs.startPage, configs.allRecordsFetchedTillNow, true)
                        resetAll();
                    } else {
                        setError(response)
                    }
                } else if (orderType === "buy") {
                    response = await manualOrderPunch(customerId, companyId, price, quantity, distributor ? distributor.id : "", allow_regular_commission ? "" : upmark, allow_regular_commission ? "" : upmarkPay, allowUserUpdate, allow_regular_commission, allow_advance_dealer_delivery, deal_done_by_admin_id.id);
                    if (response.success) {
                        setShowSuccess(true)
                        resetAll();
                    } else {
                        setError(response)
                    }
                } else if (orderType === "sell") {
                    response = await sellManualOrderPunch(customerId, companyId, price, quantity, dealerOrder, distributor ? distributor.id : "", upmark, upmarkPay, deal_done_by_admin_id.id, esopHolder, allowUserUpdate ? 1 : 0)
                    if (response.success) {
                        setShowSuccess(true)
                        resetAll();
                    } else {
                        setError(response)
                    }
                } else {
                    setError("You are not authorized to manually punch order.")
                }
            }

        } catch (error) {
            console.error(error)
        } finally {
            if (document.getElementById("manualPunchBtn")) {
                document.getElementById("manualPunchBtn").classList.toggle("d-none")
                document.getElementById("manualPunchBtnLoader").classList.toggle("d-none")
            }
        }
    }

    function resetAll() {
        try {
            setCustomer("")
            setEmail("")
            setName("")
            setPan("")
            setMobile("")
            setCustomerId("")
            setQuantity("")
            setPrice("")
            setError("")
            setOrderType("buy")
            setDealerOrder(0)
            setEsopHolder(false)
            setDistributor("")
            setUpmark("")
            setUpmarkPay("")
            setEditManualPunch(false)
            if (setEditManualPunchSell) setEditManualPunchSell(false)
            setAllowUserUpdate(0)
            setAllow_regular_commission(0)
            setAllow_advance_dealer_delivery(0)
            setCompanyId("")
            setCompnaySlabs("")
            setInventory("")
        } catch (error) {
            console.error(error);

        }
    }

    // calculate cost based on quantity
    function calculateCost(slabs, quantity) {
        try {
            if (slabs && slabs.length > 0) {
                let result = slabs[0];
                slabs.forEach((slab, key) => {
                    if ((quantity >= slab.min && key === (slabs.length - 1)) || (quantity >= slab.min && quantity <= slab.max)) {
                        slab["cost"] = slab.updatedPrice ? quantity * slab.updatedPrice : quantity * slab.price;
                        result = slab;
                    }
                })
                setError("")
                return result;
            } else {
                return { error: `No slabs available.` };
            }
        } catch (error) {
            console.error(error);
        }
    }

    return (

        <div id="mpOrder" className="smPO-container">
            <div className="col-12 text-left">
                <p className="h3 text-custom-greyDark mb-0">{editManualPunchSell ? `Edit Order - ${editManualPunchSell.id}` : editManualPunch && editManualPunch.company_id ? `Edit Order - ${editManualPunch.id}` : "Punch Manual Order"}</p>
            </div>
            {kycVerifiedList && companyList ?
                <div className="smPOI-container">
                    <form action="">
                        {/* Sell edit: quantity, price, allow_user_update, new_user_id, upmark, upmark_final_pay, distributor_id, is_dealer_order, esop_holder, deal_done_by_admin_id editable */}
                        {editManualPunchSell ? (
                            <>
                                <div className="form-row py-3">
                                    {editManualPunchSell.allow_user_update ?
                                        <div className="col-lg-3 form-group">
                                            <label>Customer Name/E-mail</label>
                                            {kycVerifiedList ? <Autocomplete
                                                className="f-12"
                                                id="emailIPSellEdit"
                                                placeholder="E-mail"
                                                getOptionLabel={option => option && option.email ? `${option.name} - ${option.email}` : ""}
                                                onChange={handleNameChange}
                                                options={kycVerifiedList}
                                                value={customer}
                                                renderInput={(params) => <TextField {...params} placeholder="E-mail" className="f-12" onChange={getKYCVerifiedCustomer} />}
                                            /> : null}
                                        </div>
                                        : <div className="col-lg-3 form-group">
                                            <label>Customer Name</label>
                                            <input type="text" className="form-control f-10 py-2" value={(customer && customer.name) || (editManualPunchSell.user && editManualPunchSell.user.name) || ""} disabled />
                                        </div>}
                                    <div className="col-lg-3 form-group">
                                        <label>Customer Mobile</label>
                                        <input type="text" className="form-control f-10 py-2" value={mobile ? mobile : ""} placeholder="Mobile No" disabled />
                                    </div>
                                    <div className="col-lg-3 form-group">
                                        <label>Customer Pan Number</label>
                                        <input type="text" className="form-control f-10 py-2" value={pan ? pan : ""} placeholder="PAN No" disabled />
                                    </div>
                                    <div className="col-lg-3 form-group d-flex flex-column justify-content-center">
                                        <label><span className="font-weight-bold">Allow Customer Update:</span> {editManualPunchSell.allow_user_update ? "Yes" : "No"}</label>
                                    </div>
                                </div>
                                <div className="form-row py-3">
                                    <div className="col-lg-3 form-group">
                                        <label>Company Name</label>
                                        <input type="text" className="form-control f-10 py-2" value={editManualPunchSell.company_name || (editManualPunchSell.company && editManualPunchSell.company.name) || ""} disabled />
                                    </div>
                                    <div className="col-lg-3 form-group">
                                        <label>Order Type</label>
                                        <input type="text" className="form-control f-10 py-2" value="Sell" disabled />
                                    </div>
                                    <div className="col-lg-3 form-group">
                                        <label>Quantity</label>
                                        <input type="text" className="form-control f-10 py-2" placeholder="Qty" value={quantity} onChange={(e) => setQuantity(e.target.value)} />
                                    </div>
                                    <div className="col-lg-3 form-group">
                                        <label>Price/Share</label>
                                        <input type="text" className="form-control f-10 py-2" placeholder="Price" value={price} onChange={(e) => setPrice(e.target.value)} />
                                    </div>
                                </div>
                                <div className="form-row py-3">
                                    <div className="col-lg-3 form-group d-flex align-items-center">
                                        <input type="checkbox" id="dealerOrderSellEdit" checked={!!dealerOrder} onChange={(e) => setDealerOrder(e.target.checked ? 1 : 0)} />
                                        <label className="m-0 ml-1" htmlFor="dealerOrderSellEdit">Dealer Order</label>
                                    </div>
                                    <div className="col-lg-3 form-group d-flex align-items-center">
                                        <input type="checkbox" id="esopHolderSellEdit" checked={!!esopHolder} onChange={(e) => setEsopHolder(e.target.checked ? 1 : 0)} />
                                        <label className="m-0 ml-1" htmlFor="esopHolderSellEdit">ESOP holder</label>
                                    </div>
                                </div>
                                <div className="form-row py-3">
                                    <div className="col-lg-4 form-group">
                                        <label>Distributor</label>
                                        <Autocomplete
                                            className="f-12"
                                            id="distributorSellEdit"
                                            value={distributor && distributor.id ? distributor : null}
                                            placeholder="Distributor"
                                            getOptionLabel={option => option ? `${option.name || ""}${option.email ? ` - ${option.email}` : ""}` : ""}
                                            getOptionSelected={(option, val) => option && val && option.id === val.id}
                                            onChange={(e, value) => {
                                                if (!value) {
                                                    setDistributor("")
                                                    setUpmark("")
                                                    setUpmarkPay("")
                                                } else {
                                                    setDistributor(value)
                                                }
                                            }}
                                            options={distributorList || []}
                                            renderInput={(params) => <TextField {...params} placeholder="Distributor" className="f-12" />}
                                        />
                                    </div>
                                    <div className="col-lg-4 form-group">
                                        <label>Upmark Value</label>
                                        <input type="number" className="form-control f-10 py-2" placeholder="Upmark" value={upmark} disabled={!(distributor && distributor.id)} onChange={(e) => {
                                            setUpmark(e.target.value)
                                        }} />
                                    </div>
                                    <div className="col-lg-4 form-group">
                                        <label>Upmark Final Pay Value</label>
                                        <input type="number" className="form-control f-10 py-2" placeholder="Upmark Final Pay" value={upmarkPay} disabled={!(distributor && distributor.id)} onChange={(e) => {
                                            setUpmarkPay(e.target.value)
                                        }} />
                                    </div>
                                </div>
                                <div className="form-row py-3">
                                    <div className="col-lg-6 form-group">
                                        <label>RM Name</label>
                                        <input type="text" className="form-control f-10 py-2" value={(editManualPunchSell.relationship_manager && editManualPunchSell.relationship_manager.name) || (customer && customer.relationship_manager && customer.relationship_manager.name) || (editManualPunchSell.user && editManualPunchSell.user.relationship_manager && editManualPunchSell.user.relationship_manager.name) || ""} disabled />
                                    </div>
                                    <div className="col-lg-6 form-group">
                                        <label>Deal Done By Admin ID</label>
                                        {adminList ? <Autocomplete
                                            className="f-12"
                                            id="dealDoneBySellEdit"
                                            value={deal_done_by_admin_id ? deal_done_by_admin_id : ""}
                                            placeholder="Admin Name"
                                            getOptionLabel={option => option.name}
                                            onChange={handleRMChange}
                                            options={adminList}
                                            renderInput={(params) => <TextField {...params} placeholder="Manager Name" className="f-12" />}
                                        /> : null}
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="form-row py-3">
                                    {editManualPunch && !editManualPunch.allow_user_update ?
                                        <div className="col-lg-3 form-group">
                                            <label>Customer Name</label>
                                            <input type="text" className="form-control f-10 py-2" defaultValue={editManualPunch.user ? editManualPunch.user.name : ""} placeholder="Customer Name" disabled />
                                        </div>
                                        : <div className="col-lg-3 form-group">
                                            <label>Customer Name/E-mail</label>
                                            {kycVerifiedList ? <Autocomplete
                                                className="f-12"
                                                id="emailIP"
                                                placeholder="E-mail"
                                                getOptionLabel={option => option && option.email ? `${option.name} - ${option.email}` : ""}
                                                onChange={handleNameChange}
                                                options={kycVerifiedList}
                                                value={customer}
                                                renderInput={(params) => <TextField {...params} placeholder="E-mail" className="f-12" onChange={getKYCVerifiedCustomer} />}
                                            /> : null}
                                        </div>}
                                    <div className="col-lg-3 form-group">
                                        <label>Customer Mobile</label>
                                        <input type="text" className="form-control f-10 py-2" value={mobile ? mobile : ""} placeholder="Mobile No" disabled />
                                    </div>
                                    <div className="col-lg-3 form-group">
                                        <label>Customer Pan Number</label>
                                        <input type="text" className="form-control f-10 py-2" value={pan ? pan : ""} placeholder="PAN No" disabled />
                                    </div>
                                    {!editManualPunch ?
                                        <div className="col-lg-3 form-group d-flex flex-column justify-content-between">
                                            <div>
                                                <input type="checkbox" className="" placeholder="Allow Customer Update" checked={allowUserUpdate} onChange={(e) => {
                                                    setAllowUserUpdate(e.target.checked)
                                                }} />
                                                <label className="font-weight-bold m-0 ml-2">Allow Customer Update</label>
                                            </div>
                                            {orderType === "buy" ?
                                                <div>
                                                    <input type="checkbox" className="" placeholder="Advance Delivery" checked={allow_advance_dealer_delivery} onChange={(e) => {
                                                        setAllow_advance_dealer_delivery(e.target.checked)
                                                    }} />
                                                    <label className="font-weight-bold m-0 ml-2">Advance Delivery</label>
                                                </div> : null}
                                        </div>
                                        : <div className="col-lg-3 form-group d-flex flex-column justify-content-between">
                                            <label><span className="font-weight-bold">Allow Customer Update:</span> {editManualPunch.allow_user_update ? "Yes" : "No"}</label>
                                            {orderType === "buy" ? <label><span className="font-weight-bold">Advance Payment:</span> {editManualPunch.allow_advance_dealer_delivery ? "Yes" : "No"}</label> : null}
                                        </div>}
                                </div>
                                <div className="form-row py-3">
                                    {!editManualPunch || (editManualPunch && (!editManualPunch.company_id && (editManualPunch.company && !editManualPunch.company.id))) ?
                                        <div className="col-lg-4 form-group">
                                            <label>Company Name</label>
                                            {companyList ? <Autocomplete
                                                className="f-12"
                                                id="companyIP"
                                                placeholder="Compnay Name"
                                                getOptionLabel={option => option.name}
                                                onChange={handleCompanyChange}
                                                options={companyList}
                                                value={companyList.find(item => item.id === companyId) || ""}
                                                renderInput={(params) => <TextField {...params} placeholder="Company Name" className="f-12" />}
                                            /> : null}
                                        </div>
                                        : <div className="col-lg-4 form-group">
                                            <label>Company</label>
                                            <input type="text" className="form-control f-10 py-2" value={editManualPunch.company ? editManualPunch.company.name : editManualPunch.company_name ? editManualPunch.company_name : ""} placeholder="Company Name" disabled />
                                        </div>}
                                    <div className="col-lg-4 form-group">
                                        <label>Order Type</label>
                                        {!editManualPunch || (editManualPunch && !editManualPunch.price_per_share) ?
                                            <select name="" id="" className="form-control f-10 py-2 dropDown" value={orderType} onChange={(e) => {
                                                setOrderType(e.target.value)
                                                if (e.target.value !== "sell") {
                                                    setEsopHolder(false)
                                                }
                                            }}>
                                                {allowedFunc.includes(configs.functionList["buy_module:buy_order_manual_punching"]) ? <option value="buy">Buy</option> : null}
                                                {allowedFunc.includes(configs.functionList["sell_module:sell_order_manual_punching"]) ? <option value="sell">Sell</option> : null}
                                            </select>
                                            : <input type="text" className="form-control f-10 py-2" defaultValue="Buy" placeholder="Order Type" disabled />}
                                    </div>
                                    <div className="col-lg-4 form-group">
                                        <div><p><b>Physical Inventory: </b>{formatNumber(inventory && inventory.physical_inventory ? inventory.physical_inventory : "0")}</p></div>
                                        <div><p><b>Net Inventory: </b>{formatNumber(inventory && inventory.net_inventory ? inventory.net_inventory : "0")}</p></div>
                                        <div><p><b>Available Quantity: </b>{formatNumber(inventory && inventory.available_quantity ? inventory.available_quantity : "0")}</p></div>

                                    </div>
                                </div>
                                <div className="form-row py-3">
                                    <div className="col-lg-4 form-group">
                                        <label>Quantity</label>
                                        <input type="text" className="form-control f-10 py-2" placeholder="Qty" value={quantity} onChange={(e) => {
                                            setQuantity(e.target.value)
                                            let cost = calculateCost(companySlabs.slabs, e.target.value);
                                            if (cost.error) {
                                                setError(cost.error)
                                            } else {
                                                setPrice(cost.updatedPrice ? cost.updatedPrice : cost.price)
                                            }
                                        }} />
                                    </div>
                                    <div className="col-lg-4 form-group">
                                        <label>Price/Share</label>
                                        <input type="text" className="form-control f-10 py-2" placeholder="Price" value={price} onChange={(e) => {
                                            setPrice(e.target.value)
                                        }} />
                                    </div>
                                    {orderType === "sell" ?
                                        <div className="col-lg-4 form-group d-flex flex-column justify-content-center">
                                            <div className="d-flex align-items-center mb-2">
                                                <input type="checkbox" id="dealerOrderMp" placeholder="Dealer Order" checked={!!dealerOrder} onChange={(e) => {
                                                    setDealerOrder(e.target.checked ? 1 : 0)
                                                }} />
                                                <label className="m-0 ml-1" htmlFor="dealerOrderMp">Dealer Order</label>
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <input type="checkbox" id="esopHolderMp" checked={esopHolder} onChange={(e) => setEsopHolder(e.target.checked)} />
                                                <label className="m-0 ml-1" htmlFor="esopHolderMp">ESOP holder</label>
                                            </div>
                                        </div>
                                        : <div className="col-lg-4 form-group">
                                            <b>Buy Price Slabs</b>
                                            <div className="d-flex justify-content-between">
                                                <p>Quantity</p>
                                                <p>Rate</p>
                                            </div>
                                            <div>
                                                {companySlabs.slabs && companySlabs.slabs.map((item, index) => {
                                                    return <div key={index} className="d-flex justify-content-between">
                                                        <p>{index !== (companySlabs.slabs.length - 1) ? `${item.min} - ${item.max}` : `>= ${item.min}`}</p>
                                                        <p>{formatCurrency(parseFloat(item.price))}</p>
                                                    </div>
                                                })}
                                            </div>
                                        </div>}
                                </div>
                                {distributor && distributor.id ?
                                    <div className="form-row py-3">
                                        <div className="col-lg-3 form-group">
                                            <label>Distributor Name</label>
                                            <input type="text" className="form-control f-10 py-2" value={distributor ? distributor.name : ""} placeholder="Distributor" disabled />
                                        </div>
                                        <div className="col-lg-3 form-group">
                                            <label>Upmark Value</label>
                                            <input type="number" className="form-control f-10 py-2" placeholder="Upmark" value={upmark} disabled={allow_regular_commission ? true : false} onChange={(e) => {
                                                setUpmark(e.target.value)
                                            }} />
                                        </div>
                                        <div className="col-lg-3 form-group">
                                            <label>Upmark final pay Value</label>
                                            <input type="number" className="form-control f-10 py-2" placeholder="Upmark Final Pay" value={upmarkPay} disabled={allow_regular_commission ? true : false} onChange={(e) => {
                                                setUpmarkPay(e.target.value)
                                            }} />
                                        </div>
                                        {!editManualPunch ?
                                            <div className="col-lg-3 form-group d-flex align-items-center">
                                                <input type="checkbox" className="" placeholder="Dealer Order" checked={allow_regular_commission} onChange={(e) => {
                                                    setAllow_regular_commission(e.target.checked)
                                                    setUpmark("")
                                                    setUpmarkPay("")
                                                }} />
                                                <label className="m-0 ml-1">Allow Regular Commission</label>
                                            </div>
                                            : <div className="col-lg-3 form-group">
                                                <label>Allowed Regular Commission</label>
                                                <input type="text" className="form-control f-10 py-2" value={editManualPunch.allow_regular_commission ? "Yes" : "No"} placeholder="Company Name" disabled />
                                            </div>}
                                    </div>
                                    : null}
                                <div className="form-row py-3">
                                    <div className="col-lg-6 form-group">
                                        <label>RM Name</label>
                                        <input type="text" className="form-control f-10 py-2" defaultValue={editManualPunch && editManualPunch.user && editManualPunch.user.relationship_manager ? editManualPunch.user.relationship_manager.name : customer && customer.relationship_manager ? customer.relationship_manager.name : ""} placeholder="RM Name" disabled />
                                    </div>
                                    <div className="col-lg-6 form-group">
                                        <label>Deal Done By Admin ID</label>
                                        {adminList ? <Autocomplete
                                            className="f-12"
                                            id="companyIP"
                                            value={deal_done_by_admin_id ? deal_done_by_admin_id : ""}
                                            placeholder="Admin Name"
                                            getOptionLabel={option => option.name}
                                            onChange={handleRMChange}
                                            options={adminList}
                                            renderInput={(params) => <TextField {...params} placeholder="Manager Name" className="f-12" />}
                                        /> : null}
                                    </div>
                                </div>
                            </>
                        )}
                        <div className="form-check p-0">
                            <p className="text-danger" id="manualOrderPunchError">{error}</p>
                        </div>

                        <div className="col-12 d-flex justify-content-center mt-3">
                            <button id="manualPunchBtn" className="btn btn-primary" onClick={(e) => {
                                e.preventDefault()
                                manualPunch()
                            }}>Submit</button>
                            <div id="manualPunchBtnLoader" className='animBtn d-none'><div className='gSignIn-Anim'></div></div>
                            {(editManualPunch || editManualPunchSell) ? <button id="cancelBtn" className="btn btn-danger ml-2" onClick={(e) => {
                                e.preventDefault()
                                resetAll()
                            }}>Cancel</button> : null}
                        </div>
                    </form>
                </div>
                : <div className="loader"></div>}
        </div>

    )
}